// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing_left_outer .market_section.dash_ct_pnl {
  margin-top: 28px;
}

.dash_ct_panel {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(246, 207, 37, 0.18);
  border-radius: 22px;
  background:
    radial-gradient(900px 280px at 100% -40%, rgba(246, 207, 37, 0.07), transparent 55%),
    radial-gradient(700px 240px at -10% 120%, rgba(37, 99, 235, 0.12), transparent 60%),
    linear-gradient(180deg, #101010 0%, #0a0a0a 100%);
}

.dash_ct_panel::before {
  content: "";
  position: absolute;
  top: 0;
  left: 24px;
  right: 24px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(246, 207, 37, 0.7), transparent);
}

.dash_ct_head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 26px 26px 0;
}

.dash_ct_kicker {
  display: block;
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #f6cf25;
}

.dash_ct_head h4 {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.6px;
  line-height: 1.15;
}

.dash_ct_more {
  flex-shrink: 0;
  padding: 8px 14px;
  border: 1px solid rgba(246, 207, 37, 0.28);
  border-radius: 50px;
  color: #f6cf25;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-decoration: none;
}

.dash_ct_more:hover {
  background: rgba(246, 207, 37, 0.08);
  color: #f6cf25;
}

.dash_ct_hero {
  display: grid;
  grid-template-columns: 1.7fr 1fr;
  gap: 18px;
  padding: 22px 26px 10px;
}

.dash_ct_hero_main {
  padding: 26px 26px 24px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  background:
    radial-gradient(520px 160px at 0% 0%, rgba(37, 99, 235, 0.18), transparent 70%),
    rgba(255, 255, 255, 0.02);
}

.dash_ct_hero_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.dash_ct_hero_main label {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: #9b9999;
}

.dash_ct_tone {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.dash_ct_tone::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.dash_ct_tone_up {
  color: #5ec732;
  background: rgba(94, 199, 50, 0.1);
}

.dash_ct_tone_down {
  color: #f52534;
  background: rgba(245, 37, 52, 0.1);
}

.dash_ct_tone_flat {
  color: #cfcfcf;
  background: rgba(255, 255, 255, 0.06);
}

.dash_ct_hero_main h2 {
  margin: 0;
  font-size: 42px;
  font-weight: 800;
  letter-spacing: -1.2px;
  line-height: 1.05;
  color: #fff;
}

.dash_ct_hero_main h2 small {
  margin-left: 8px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #9b9999;
  vertical-align: 8px;
}

.dash_ct_hero_main p {
  margin: 12px 0 0;
  font-size: 13px;
  color: #8a8a8a;
}

.dash_ct_stats {
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 12px;
}

.dash_ct_stat {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 18px 20px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.02);
}

.dash_ct_stat_n {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.6px;
  color: #fff;
  line-height: 1.1;
}

.dash_ct_stat label {
  margin-top: 6px;
  font-size: 12px;
  color: #8a8a8a;
}

.dash_ct_list {
  padding: 6px 26px 26px;
}

.dash_ct_list_title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 10px 0 14px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #8a8a8a;
}

.dash_ct_list_title::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
}

.dash_ct_row {
  display: grid;
  grid-template-columns: 40px 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 8px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.02);
  text-decoration: none;
  color: inherit;
}

.dash_ct_row:last-child {
  margin-bottom: 0;
}

.dash_ct_row:hover {
  border-color: rgba(246, 207, 37, 0.28);
  background: rgba(246, 207, 37, 0.04);
}

.dash_ct_avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(246, 207, 37, 0.28);
  background: #141414;
  color: #f6cf25;
  font-size: 14px;
  font-weight: 700;
}

.dash_ct_master {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.dash_ct_master strong {
  display: block;
  overflow: hidden;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dash_ct_chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  background: transparent;
  color: #9b9999;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.dash_ct_chip.following {
  color: #5ec732;
  border-color: rgba(94, 199, 50, 0.35);
}

.dash_ct_amount {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.2px;
  color: #fff;
  white-space: nowrap;
}

.dash_ct_pnl .ct-pnl-positive,
.dash_ct_amount.ct-pnl-positive,
.dash_ct_hero_main h2.ct-pnl-positive {
  color: #5ec732 !important;
}

.dash_ct_pnl .ct-pnl-negative,
.dash_ct_amount.ct-pnl-negative,
.dash_ct_hero_main h2.ct-pnl-negative {
  color: #f52534 !important;
}

.dash_ct_empty {
  padding: 28px 16px 18px;
  text-align: center;
}

.dash_ct_empty p {
  margin: 0;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.dash_ct_empty span {
  display: block;
  margin: 6px 0 16px;
  color: #8a8a8a;
  font-size: 13px;
}

.dash_ct_empty a {
  display: inline-flex;
  padding: 9px 18px;
  border-radius: 50px;
  background: #2563eb;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}

@media (max-width: 767px) {
  .dash_ct_head,
  .dash_ct_hero,
  .dash_ct_list {
    padding-left: 16px;
    padding-right: 16px;
  }

  .dash_ct_head h4 {
    font-size: 22px;
  }

  .dash_ct_hero {
    grid-template-columns: 1fr;
  }

  .dash_ct_hero_main h2 {
    font-size: 32px;
  }

  .dash_ct_stats {
    grid-template-rows: none;
    grid-template-columns: 1fr 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Dashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB;;;qDAGmD;AACrD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB;;6BAE2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;AACF","sourcesContent":[".listing_left_outer .market_section.dash_ct_pnl {\n  margin-top: 28px;\n}\n\n.dash_ct_panel {\n  position: relative;\n  overflow: hidden;\n  border: 1px solid rgba(246, 207, 37, 0.18);\n  border-radius: 22px;\n  background:\n    radial-gradient(900px 280px at 100% -40%, rgba(246, 207, 37, 0.07), transparent 55%),\n    radial-gradient(700px 240px at -10% 120%, rgba(37, 99, 235, 0.12), transparent 60%),\n    linear-gradient(180deg, #101010 0%, #0a0a0a 100%);\n}\n\n.dash_ct_panel::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 24px;\n  right: 24px;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(246, 207, 37, 0.7), transparent);\n}\n\n.dash_ct_head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 26px 26px 0;\n}\n\n.dash_ct_kicker {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: #f6cf25;\n}\n\n.dash_ct_head h4 {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.6px;\n  line-height: 1.15;\n}\n\n.dash_ct_more {\n  flex-shrink: 0;\n  padding: 8px 14px;\n  border: 1px solid rgba(246, 207, 37, 0.28);\n  border-radius: 50px;\n  color: #f6cf25;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-decoration: none;\n}\n\n.dash_ct_more:hover {\n  background: rgba(246, 207, 37, 0.08);\n  color: #f6cf25;\n}\n\n.dash_ct_hero {\n  display: grid;\n  grid-template-columns: 1.7fr 1fr;\n  gap: 18px;\n  padding: 22px 26px 10px;\n}\n\n.dash_ct_hero_main {\n  padding: 26px 26px 24px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 16px;\n  background:\n    radial-gradient(520px 160px at 0% 0%, rgba(37, 99, 235, 0.18), transparent 70%),\n    rgba(255, 255, 255, 0.02);\n}\n\n.dash_ct_hero_top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.dash_ct_hero_main label {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.6px;\n  text-transform: uppercase;\n  color: #9b9999;\n}\n\n.dash_ct_tone {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 50px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n}\n\n.dash_ct_tone::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.dash_ct_tone_up {\n  color: #5ec732;\n  background: rgba(94, 199, 50, 0.1);\n}\n\n.dash_ct_tone_down {\n  color: #f52534;\n  background: rgba(245, 37, 52, 0.1);\n}\n\n.dash_ct_tone_flat {\n  color: #cfcfcf;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.dash_ct_hero_main h2 {\n  margin: 0;\n  font-size: 42px;\n  font-weight: 800;\n  letter-spacing: -1.2px;\n  line-height: 1.05;\n  color: #fff;\n}\n\n.dash_ct_hero_main h2 small {\n  margin-left: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  color: #9b9999;\n  vertical-align: 8px;\n}\n\n.dash_ct_hero_main p {\n  margin: 12px 0 0;\n  font-size: 13px;\n  color: #8a8a8a;\n}\n\n.dash_ct_stats {\n  display: grid;\n  grid-template-rows: 1fr 1fr;\n  gap: 12px;\n}\n\n.dash_ct_stat {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 18px 20px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.dash_ct_stat_n {\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.6px;\n  color: #fff;\n  line-height: 1.1;\n}\n\n.dash_ct_stat label {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #8a8a8a;\n}\n\n.dash_ct_list {\n  padding: 6px 26px 26px;\n}\n\n.dash_ct_list_title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 10px 0 14px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  color: #8a8a8a;\n}\n\n.dash_ct_list_title::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.dash_ct_row {\n  display: grid;\n  grid-template-columns: 40px 1fr auto;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  margin-bottom: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.02);\n  text-decoration: none;\n  color: inherit;\n}\n\n.dash_ct_row:last-child {\n  margin-bottom: 0;\n}\n\n.dash_ct_row:hover {\n  border-color: rgba(246, 207, 37, 0.28);\n  background: rgba(246, 207, 37, 0.04);\n}\n\n.dash_ct_avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(246, 207, 37, 0.28);\n  background: #141414;\n  color: #f6cf25;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.dash_ct_master {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.dash_ct_master strong {\n  display: block;\n  overflow: hidden;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dash_ct_chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 8px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  background: transparent;\n  color: #9b9999;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n}\n\n.dash_ct_chip.following {\n  color: #5ec732;\n  border-color: rgba(94, 199, 50, 0.35);\n}\n\n.dash_ct_amount {\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.dash_ct_pnl .ct-pnl-positive,\n.dash_ct_amount.ct-pnl-positive,\n.dash_ct_hero_main h2.ct-pnl-positive {\n  color: #5ec732 !important;\n}\n\n.dash_ct_pnl .ct-pnl-negative,\n.dash_ct_amount.ct-pnl-negative,\n.dash_ct_hero_main h2.ct-pnl-negative {\n  color: #f52534 !important;\n}\n\n.dash_ct_empty {\n  padding: 28px 16px 18px;\n  text-align: center;\n}\n\n.dash_ct_empty p {\n  margin: 0;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.dash_ct_empty span {\n  display: block;\n  margin: 6px 0 16px;\n  color: #8a8a8a;\n  font-size: 13px;\n}\n\n.dash_ct_empty a {\n  display: inline-flex;\n  padding: 9px 18px;\n  border-radius: 50px;\n  background: #2563eb;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n@media (max-width: 767px) {\n  .dash_ct_head,\n  .dash_ct_hero,\n  .dash_ct_list {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .dash_ct_head h4 {\n    font-size: 22px;\n  }\n\n  .dash_ct_hero {\n    grid-template-columns: 1fr;\n  }\n\n  .dash_ct_hero_main h2 {\n    font-size: 32px;\n  }\n\n  .dash_ct_stats {\n    grid-template-rows: none;\n    grid-template-columns: 1fr 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
